import { Injectable } from "@angular/core";
import { DynamicHeaderMenuConfig } from '../../../../app/_theme/configs/dynamic-header-menu.config';
import { AccountFeaturesService } from "../account-features/account-features.service";
import { DynamicHeaderMenuService } from "../services/dynamic-header-menu.service";
import { filter, take } from "rxjs/operators";

@Injectable({
    providedIn: "root"
})
export class UrlAccessService {
    private menu: any = DynamicHeaderMenuConfig;
    public simplifiedMenuItems: any;
    public url: any;
    accountFeatures: any;
    showAIOps3 = false;
    showAIOps7 = false;
    private readonly redirectPriorityPages: string[] = [
      'dashboard',
      'alerts',
      'incidents',
      'users',
      'groups-schedules',
      'integrations',
      'call-routing',
      'escalation-policies',
      'response-plays',
      'workflows',
      'administration',
      'business-services',
      'reports',
      'status-page',
      'account-settings',
      'billing',
      'subscription',
    ];
    private readonly redirectablePages = new Set<string>(this.redirectPriorityPages);

     constructor(
      private readonly accountFeaturesService: AccountFeaturesService,
      private readonly dMenu: DynamicHeaderMenuService
    ) {
    }

    getAccountFeatures() {
      this.accountFeaturesService.getAppAccountFeatures(localStorage.getItem('token')).subscribe((res) => {
        this.accountFeaturesService.updateAccountFeatures(res);
      });
    }
    
    getActualRedirectUrl(abilities,accName,currentUser) {
        if(abilities.user_typeid == 4) {
          this.url = '/' + accName + '/alerts';
        } else if(abilities.user_typeid == 3 && abilities.account_verified) {
            this.url = '/' + accName + '/subscription';
        } else {
          if (abilities.reporting_dashboards && abilities.alerts_list) {
            this.url = '/' + accName + '/dashboard';
          } else if (abilities.alerts_list) {
            this.url = '/' + accName + '/alerts';
          } else {
            this.url = '/' + accName + '/users/edit/' + currentUser['user_id'];
          }
        }
        return this.url;
    }
    getPermissionCheck(abilities) {
      // /**
      //  * The AIOps menu is added for redirect to default or prev page if no permission.
      //  * Also this menu is not visible in UI because the title is empty.
      //  * The Actual AIOps menu will added if the Account Features API returns ai_assist and ai_assist_mock is true.
      //  */
      this.accountFeaturesService.accountFeaturesSubject
        .pipe(
          filter(data => !!data), // Wait for first non-empty value
          take(1)
        )
        .toPromise()
        .then(res => {
          this.accountFeatures = res;

          const ai_assist = this.accountFeatures[0]?.ai_assist;
          const ai_merge = this.accountFeatures[0]?.ai_merge;
          const ai_assist_mock = this.accountFeatures[0]?.ai_assist_mock;

          const updatedMenuConfig = { ...this.dMenu.getMenu() };
          this.showAIOps3 = !!(ai_assist || ai_merge);
          this.showAIOps7 = !!ai_assist_mock;

          const aiopsRouteExists = updatedMenuConfig.items.some(e => e.page.includes("/aiops"));

          if (!this.showAIOps3 && !this.showAIOps7 && !aiopsRouteExists) {
            updatedMenuConfig.items.push({
              title: '',
              page: '/aiops',
              icon: 'flaticon-interface-7',
              permissions: true,
            });
            this.dMenu.setMenu(updatedMenuConfig);
          }
        });
        const mainMenuItems = this.menu.items.flatMap(item => {
            if (item.submenu) {
              return item.submenu.map(subItem => ({
                page: subItem.page.replace('/',''),
                permissions: subItem.permissions
              }));
            } else {
              return {
                page: item.page.replace('/', ''),
                permissions: item.permissions
              };
            }
        });
        const integrationChildMenu = this.menu.integrationChildItems.flatMap(item => {
          return {
                page: item.page.replace('/', ''),
                permissions: item.permissions
          }
        })
        const administrationChildMenu = this.menu.administrationChildItems.flatMap(item => {
          return {
                page: item.page.replace('/', ''),
                permissions: item.permissions
          }
        });
        const userChildMenu = this.menu.userchildItems.flatMap(item => {
          return {
                page: item.page.replace('/', ''),
                permissions: item.permissions
          }
        })
        this.simplifiedMenuItems = [...mainMenuItems, ...integrationChildMenu, ...administrationChildMenu, ...userChildMenu]
        let value: string;
        if (abilities.user_typeid == 3 || 
          abilities.user_typeid == 4 || 
          !abilities.reporting_dashboards ||  abilities.alerts_list  == 0) { value = 'dashboard'; this.filteredvalue(value) }
        if (abilities.user_typeid == 3 || abilities.alerts_list  == 0) { value = 'alerts'; this.filteredvalue(value) }
        if (!abilities.incidents || abilities.user_typeid == 3 || abilities.alerts_list == 0) { value = 'incidents'; this.filteredvalue(value) }
        if (abilities.users_list == 0) { value = 'users'; this.filteredvalue(value) }
        if (abilities.users_list == 0 || abilities.users_add_update == 0) { value = 'add-user'; this.filteredvalue(value) }
        if (abilities.groups_list == 0 || abilities.user_typeid == 3 || abilities.user_typeid == 4) { value = 'groups-schedules'; this.filteredvalue(value) }
        if ((abilities.inbound_integrations == 0 && abilities.outbound_integrations_maintenance == 0)|| abilities.user_typeid == 3 || abilities.user_typeid == 4 )
           { 
             if(abilities?.integrations_view == 0){
              value = 'integrations';
            this.filteredvalue(value);
            }
          }
        if (abilities.inbound_integrations == 0 || abilities.user_typeid == 3 || abilities.user_typeid == 4) {  if(abilities?.integrations_view == 0){value = 'aiops'; this.filteredvalue(value)}}
        if (!abilities.services || abilities.user_typeid == 3) {  if(abilities?.services_view == 0){value = 'business-services'; this.filteredvalue(value) }}
        if (abilities.services && (abilities.services_maintenance == 0 && abilities.services_subscriber == 0)) { if(abilities?.services_view == 0){value = 'business-services'; this.filteredvalue(value) }}
        if (!abilities.workflows || abilities.workflows_list == 0 || abilities.user_typeid == 3 || abilities.user_typeid == 4) { value = 'workflows'; this.filteredvalue(value) }
        if (!abilities.call_routing || abilities.user_typeid == 3 || abilities.user_typeid == 4) {  if(abilities?.call_routing_view != 1){value = 'call-routing'; this.filteredvalue(value) }}
        if (!abilities.escalation_policy_list || abilities.user_typeid == 3 || abilities.user_typeid == 4) { value = 'escalation-policies'; this.filteredvalue(value) }
        if (!abilities.escalation_policy_list || abilities.user_typeid == 3 || abilities.user_typeid == 4) { value = 'response-plays'; this.filteredvalue(value) }
        if (!abilities.reporting_dashboards || abilities.user_typeid == 3 || abilities.user_typeid == 4 || !abilities.reports_list) { value = 'reports'; this.filteredvalue(value) }
        if ((!abilities.topics && !abilities.bridges && !abilities.custom_alert_fields && 
          !abilities.user_attribute && (!abilities.roles && !abilities.roles_maintenance) && !abilities.postmortem) || (abilities.bridges_maintenance == 0 && 
            abilities.topics_maintenance == 0 &&
            abilities.custom_alert_fields_maintenance == 0 && 
            abilities.user_attributes_maintenance == 0&&
            abilities.roles_maintenance == 0
            ) || abilities.user_typeid == 3 || abilities.user_typeid == 4 
             ) { 
              if(abilities?.settings_view == 0){
              value = 'administration'; this.filteredvalue(value)} }
        if (abilities.billing_administration == 0 || !abilities.support_billing) { if(abilities?.settings_view == 0) {value = 'billing'; this.filteredvalue(value)}}
        if (abilities.billing_administration == 0 || !abilities.support_billing || abilities.account_verified == 0 ) { if(abilities?.settings_view == 0){value = 'subscription'; this.filteredvalue(value)}}
        if (abilities.account_settings == 0) { if (abilities?.settings_view == 0){value = 'account-settings'; this.filteredvalue(value)}}
        // for Integration Details
        if (abilities.inbound_integrations == 0) { if(abilities?.integrations_view == 0){value = 'inbound'; this.filteredvalue(value)}}
        // Outbound Details, Creation, method
        if (abilities.outbound_integrations_maintenance == 0) {  value = 'create-outbound'; this.filteredvalue(value)}
        if (abilities.outbound_integrations_maintenance == 0) {  if(abilities?.integrations_view == 0){value = 'edit-outbound'; this.filteredvalue(value)}}
        if (abilities.outbound_integrations_maintenance == 0) {  if(abilities?.integrations_view == 0){value = 'outbound-method'; this.filteredvalue(value)}}
        // Inbound log details
        if (abilities.inbound_integrations == 0) { if(abilities?.integrations_view == 0){value = 'message-detail'; this.filteredvalue(value)}}//For inbound log details
        // For maintenance window
        if (abilities.advanced_integration == 0) { value = 'maintenance'; this.filteredvalue(value)}
        // For template
        if (abilities.inbound_integrations == 0) { value = 'template'; this.filteredvalue(value)}
        if (!abilities.custom_alert_fields_maintenance || !abilities.custom_alert_fields) { if (abilities?.settings_view == 0){value = 'custom-alert'; this.filteredvalue(value)}}
        if (!abilities.roles_maintenance) { if (abilities?.settings_view == 0){value = 'roles'; this.filteredvalue(value)}}
        if (!abilities.topics_maintenance || !abilities.topics) { if (abilities?.settings_view == 0){value = 'topic'; this.filteredvalue(value)}}
        return this.simplifiedMenuItems;
    }

    filteredvalue(value) {
        this.simplifiedMenuItems.map(item => {
          if(item.page == value) {
            item.permissions = true;
          }
        })
    }

    getFirstUnlockedRedirectUrl(
      abilities: any,
      accName: string,
      excludedPages: string[] = []
    ): string {
      const normalizedExcluded = new Set<string>(
        excludedPages
          .map((page) => this.normalizeRouteSegment(page))
          .filter((page) => !!page)
      );

      const permissionItems = this.getPermissionItems(abilities);
      const unlockedPage = this.findFirstUnlockedPage(permissionItems, normalizedExcluded);
      const account = this.normalizeRouteSegment(accName);

      if (unlockedPage) {
        return account ? `/${account}/${unlockedPage}` : `/${unlockedPage}`;
      }

      return account ? `/${account}/dashboard` : '/dashboard';
    }

    private getPermissionItems(abilities: any): any[] {
      if (abilities) {
        const computed = this.getPermissionCheck(abilities);
        if (Array.isArray(computed)) {
          return computed;
        }
      }

      return Array.isArray(this.simplifiedMenuItems) ? this.simplifiedMenuItems : [];
    }

    private findFirstUnlockedPage(items: any[], excludedPages: Set<string>): string {
      if (!Array.isArray(items) || items.length === 0) {
        return '';
      }

      const pageLockState = new Map<string, boolean>();
      items.forEach((item) => {
        const page = this.normalizeRouteSegment(item?.page);
        if (!page || excludedPages.has(page) || !this.redirectablePages.has(page)) {
          return;
        }

        const isLocked = item?.permissions === true;
        const existing = pageLockState.get(page);
        if (existing === undefined || (existing === true && !isLocked)) {
          pageLockState.set(page, isLocked);
        }
      });

      for (const page of this.redirectPriorityPages) {
        if (excludedPages.has(page)) {
          continue;
        }

        if (pageLockState.has(page) && pageLockState.get(page) === false) {
          return page;
        }
      }

      return '';
    }

    private normalizeRouteSegment(value: any): string {
      return String(value || '').replace(/^\/+/, '').trim().toLowerCase();
    }
}
